export const environment = {
  version: '1.0',
  production: false,
  env: 'local',
  appName: 'DynamicCarvest',
  apiURL: 'https://dyncarvestapi.test.einteligent.com/api',
  hubURL: 'https://dyncarvestapi.test.einteligent.com/hub',
  apiURLNew: 'https://dyncarvestapi.test.einteligent.com',
  arrayInputs: [
    'text-line',
    'reader-PDF',
    'break-line',
    'input-general',
    'button-general',
    'input-upload-ligh',
    'input-general-phone',
    'input-general-select',
    'input-general-number',
    'input-general-checkbox',
    'input-general-currency',
    'input-general-calendar',
    'input-general-text-area',
    'input-general-percentage',
    'input-general-autocomplete',
  ],
  arrayInputsTrasform: [
    'input-general',
    'break-line',
    'input-general-phone',
    'input-general-select',
    'input-general-number',
    'input-general-currency',
    'input-general-calendar',
    'input-general-text-area',
    'input-general-percentage',
    'input-general-autocomplete',
  ],
};
